import { render, staticRenderFns } from "./AdminImportFineCenter.vue?vue&type=template&id=c0166b4e&scoped=true&"
import script from "./AdminImportFineCenter.vue?vue&type=script&lang=js&"
export * from "./AdminImportFineCenter.vue?vue&type=script&lang=js&"
import style0 from "./AdminImportFineCenter.vue?vue&type=style&index=0&id=c0166b4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0166b4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0166b4e')) {
      api.createRecord('c0166b4e', component.options)
    } else {
      api.reload('c0166b4e', component.options)
    }
    module.hot.accept("./AdminImportFineCenter.vue?vue&type=template&id=c0166b4e&scoped=true&", function () {
      api.rerender('c0166b4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminImportFineCenter.vue"
export default component.exports